import { Outlet } from 'react-router';

export const MusicPlaylistLayout = () => <Outlet />;
